import React, { useEffect, useState } from "react";
import styles from "./subEscrow.module.css";
import { Pagination, Switch } from "@mui/material";
import SubEscrowModal from "../EscrowManagement/EscrowViewTabs/SubEscrowDetails/SubEscrowModal";
import { useAllProduct } from "../../api-context/commonApiContext";
import config from "../../service/config";
const SubEscrow = () => {
  const { clientCompany, clientId, refreshData, setRefreshData } =
    useAllProduct();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [showModal, setShowModal] = useState(false);
  const [selectedRowVal, setSelectedRowVal] = useState({});
  const [userAdded, setUserAdded] = useState(false);
  const [isSubEscrowAllowed, setIsSubEscrowAllowed] = useState(true);
  const [subEscrowList, setSubEscrowList] = useState([]);

  useEffect(() => {
    if (!clientId || !clientCompany) return;

    fetch(
      `${
        config.node_api_endpoint
      }/api/sub-escrow?client_id=${clientId}&company_name=${encodeURIComponent(
        clientCompany
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY, // ✅ your API key here
        },
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch sub_escrow");
        }
        return res.json();
      })
      .then((data) => {
        if (data.success) {
          setSubEscrowList(data.sub_escrow || []);
        } else {
          setSubEscrowList([]);
        }
      })
      .catch((err) => {
        console.error("API error:", err);
        setSubEscrowList([]);
      });
  }, [clientId, clientCompany, refreshData]);

  const paginatedReports = subEscrowList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const disableSubescrow = async (sub_escrow_id) => {
    console.log("sub_escrow_id", sub_escrow_id);

    try {
      const response = await fetch(
        `${config.node_api_endpoint}/api/disable-subescrow`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
          body: JSON.stringify({ clientId, clientCompany, sub_escrow_id }),
        }
      );

      const result = await response.json();

      if (response.ok && result.success) {
        setRefreshData(true);
        alert(`Sub-escrow ${sub_escrow_id} has been disabled.`);

        // Optional: trigger a refetch or UI update
      } else {
        alert(result.message || "Failed to disable sub-escrow.");
      }
    } catch (error) {
      console.error("Error disabling sub-escrow:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <div className="mt-2 d-flex justify-content-end align-items-center">
        <div
          className={`${styles.bulkPayoutButton} d-flex justify-content-center align-items-center p-2 gap-2`}
          onClick={() => {
            setSelectedRowVal({});
            setShowModal(true);
          }}
        >
          <img
            className={`${styles.plusCircleIcon} pe-1`}
            alt=""
            src="/pluscircle.svg"
          />
          Add Sub Escrow
        </div>
      </div>
      <div className={`${styles.root} mt-2`}>
        <section className={styles.transactionDataTable}>
          <div className={styles.top}>
            <div className={styles.reportHeader}>
              <h3 className={styles.latestAccountTransaction}>
                Sub Escrow List
              </h3>
              <div className={styles.filter}>
                <div className={styles.textField}>
                  <div className={styles.content}>
                    <img
                      className={styles.leadingIcon}
                      alt=""
                      src="/leadingicon.svg"
                    />
                    <input
                      className={styles.filterLabel}
                      placeholder="Search..."
                      type="text"
                    />
                  </div>
                </div>
                <div className={styles.reLoadTable}>
                  <img
                    className={styles.reloadIcon}
                    loading="lazy"
                    alt=""
                    src="/reload.svg"
                  />
                </div>
              </div>
            </div>
            <div className={styles.headerSeparator} />
          </div>

          <div className={styles.reportTable}>
            <div className={styles.tableHeader}>
              <div className={styles.cell}> CREATED AT</div>
              <div className={styles.cell}> SUB ESCROW ID</div>
              <div className={styles.cell}> STATUS</div>
              <div className={styles.cell}> ACTION</div>
            </div>

            {paginatedReports.map((report, index) => (
              <div className={styles.tableRow} key={index}>
                <div className={styles.cell}>{report.created_at}</div>
                <div className={styles.cell}>{report.id}</div>
                <div className={styles.cell}>{report.status}</div>
                <div className={styles.cell}>
                  <button
                    className={styles.actionButton}
                    onClick={() => {
                      disableSubescrow(report.id);
                    }}
                    disabled={report.status === "In-Active"}
                  >
                    {report.status === "In-Active" ? "" : "Disable/Delete"}
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="d-flex justify-content-end mt-3">
            <Pagination
              count={Math.ceil(subEscrowList.length / itemsPerPage)}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
          </div>
          {showModal && (
            <SubEscrowModal
              // page={"view"}
              selectedRowVal={selectedRowVal}
              onClose={() => setShowModal(false)}
              setUserAdded={setUserAdded}
            />
          )}
        </section>
      </div>

      {/* {userAdded && <UserNotification setUserAdded={setUserAdded} />} */}
    </>
  );
};

export default SubEscrow;
